const { default: Medusa } = require("@medusajs/medusa-js");

const medusaClient = new Medusa({
  baseUrl: `${process.env.REACT_APP_ORIGIN}`, // Medusa Backend URL
  maxRetries: 3,
});

export default medusaClient;
